export default __webpack_public_path__ + "c3d7dd59f845854d5af5459ef606026d.jpg";